const ANALYTICS_STORAGE_KEY = 'amhbm_analytics';

const loadAnalytics = () => {
  if (typeof window === 'undefined') {
    return {};
  }
  try {
    const raw = localStorage.getItem(ANALYTICS_STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') {
      return {};
    }
    return parsed;
  } catch (error) {
    return {};
  }
};

const saveAnalytics = (data) => {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(ANALYTICS_STORAGE_KEY, JSON.stringify(data || {}));
};

export const trackPageView = (path) => {
  if (typeof window === 'undefined') {
    return;
  }
  const analytics = loadAnalytics();
  const now = new Date().toISOString();
  const totalVisits = (analytics.totalVisits || 0) + 1;
  const perPath = analytics.perPath ? { ...analytics.perPath } : {};
  perPath[path] = (perPath[path] || 0) + 1;
  const updated = {
    ...analytics,
    totalVisits,
    perPath,
    lastVisit: now,
    firstVisit: analytics.firstVisit || now
  };
  saveAnalytics(updated);
};

export const getAnalyticsSummary = () => {
  const analytics = loadAnalytics();
  return {
    totalVisits: analytics.totalVisits || 0,
    perPath: analytics.perPath || {},
    firstVisit: analytics.firstVisit || null,
    lastVisit: analytics.lastVisit || null
  };
};

